module.exports = __webpack_public_path__ + "static/img/PHZ.ee0cb209.jpg";